import React from 'react'
import Markdown from '../Markdown/markdown'

import './content-block.scss'


const getImage = (image) => {
  const { src, srcSet } = image.sizes

  return { src, srcSet, title: image.title }
}


const ContentBlock = ({ content }) => {
  const image = content.image && content.image.length > 0 ? getImage(content.image[0]) : null

  if (content) {
    return (
      <div className="content-block-container standard-container" data-cy="contentblock">
        {content.heading || (content.body && content.body.body) ? <div className="text-content">
          {content.heading ? <h2 className="heading">
            {content.heading}
          </h2> : null}
          {content.body && content.body.body ? <div className="content">
            <Markdown content={content.body.body} />
          </div> : null}
        </div> : null}
  
        { image ? 
          <div className="feature-image-container">
            <img src={ image.src } srcSet={ image.srcSet } className="feature-image" alt={ image.title } />
          </div>
        : null}
      </div>
    )
  } else {
    return null
  }
}

export default ContentBlock


// WEBPACK FOOTER //
// ./src/components/ContentBlock/content-block.js